module.exports = __webpack_public_path__ + "img/selfie.8109a307.jpg";